import { render, staticRenderFns } from "./AssetNetworkPartnerView.vue?vue&type=template&id=8b4f07c8&scoped=true"
import script from "./AssetNetworkPartnerView.vue?vue&type=script&lang=js"
export * from "./AssetNetworkPartnerView.vue?vue&type=script&lang=js"
import style0 from "./AssetNetworkPartnerView.vue?vue&type=style&index=0&id=8b4f07c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4f07c8",
  null
  
)

export default component.exports